export const textHeaderTeam = 'Над проектом работали'

export const descriptionTeam = [
  {
    imgItem: 'team_anton_gorshkov',
    nameItem: 'Anton Gorshkov',
    roleTeam: 'Innovative алхимик',
    link: 'https://github.com/Glav-Tz',
    discr:
      'О а тут надо написать что-то про дизайн и старадания по поводу UI/UX, ну а можно просто сказать, что на его счету верстка и адаптив таких страниц как "Главная" и "Учебник"',
  },
  {
    imgItem: 'team_zmitser_furmanau',
    nameItem: 'Zmitser Furmanau',
    roleTeam: 'Cowboy оптимизации',
    link: 'https://github.com/ZmitserFurmanau',
    discr:
      'Написал чуть меньше чем "много модулей" к данному проекту, Вы сможите его узнать по таким модулям как "Авторизация" и "Статистика", а также он приложил руку к вёрстке и задаче по "Чистоте Кода"',
  },
  {
    imgItem: 'team_sergey_pobudey',
    nameItem: 'Sergey Pobudey',
    roleTeam: 'Full Stack волшебник',
    link: 'https://github.com/ps0m',
    discr:
      'Написал много модулей, Гарри Потер от мира JS/TS, золотой снитч сам ложиться к нему в руку, а Джоан Роулинг хочет написать бестселлер по таким его модулям как... да, собственно, что тут скромничать, все остальные его',
  },
]
